import { render } from "./TabItem.vue?vue&type=template&id=61448b7b&scoped=true"
import script from "./TabItem.vue?vue&type=script&lang=js"
export * from "./TabItem.vue?vue&type=script&lang=js"

import "./TabItem.vue?vue&type=style&index=0&id=61448b7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61448b7b"]])

export default __exports__